<template>
    <div class="end_success" v-loading="loading">
        <div class="end_success_box">
            <div class="title_box">
                <div class="title_text">提交成功</div>
                <div class="borders"></div>
            </div>
            <div class="img_box">
                <img src="@/assets/img/index/home/success.png" alt="">
            </div>
            <div class="success_text">提交成功</div>
            <div class="success_text2">您耐心等候，审核通过后，在个人中心-消息中查看</div>
            <div class="btn_flex">
                <div class="btns" @click="handle_home()">继续浏览</div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'




export default {
    components: {

    },
    name: "homes",
    data() {
        return {
            loading: false,
            type_end:1,//1成功
        }
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    methods: {
        //继续浏览
        handle_home(){
            this.$router.push({
                path:'/home'
            })
        },


    },

}
</script>
<style scoped lang="less">
.end_success {
   width: 100%;
   height: 600px;
   background-color: #FFFFFF;
   .end_success_box{
        width: 1440px;
        height: 100%;
        padding-top: 30px;
        margin: auto;
        .title_box{
            .title_text{
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 24px;
                color: #333333;
            }
            .borders{
                width: 100%;
                height: 1px;
                background: #D5D8DE;
                border-radius: 0px 0px 0px 0px;
                margin-top: 16px;
            }
        }
        .img_box{
            width: 80px;
            height: 80px;
            margin: auto;
            margin-top: 64px;
            img{
                width: 80px;
                height: 80px;
            }
        }
        .success_text{
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 24px;
            color: #000000;
            text-align: center;
            padding-top: 24px;
        }
        .success_text2{
            text-align: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            padding-top: 18px;
        }
        .btn_flex{
            display: flex;
            align-items: center;
            justify-content: center;
            padding-top: 33px;
            .btns{
                width: 128px;
                height: 40px;
                background: #377CFD;
                text-align: center;
                line-height: 40px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #FFFFFF;
                border-radius: 8px;
                cursor: pointer;
            }
        }
   }
}
</style>